var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadReport = function SvgDownloadReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 16.6667H15.8334V15H4.16675M15.8334 7.5H12.5001V2.5H7.50008V7.5H4.16675L10.0001 13.3333L15.8334 7.5Z",
    fill: "white"
  })));
};
export default SvgDownloadReport;